import {Avatar, Button, Col, Popconfirm, Row} from "antd";
import {FaMedal, FaPhoneAlt, FaUser, FaUserAlt, FaUserGraduate} from "react-icons/fa";
import moment from "moment";
import {maskPhone} from "../../../../Helpers/Functions";
import {BsFillBriefcaseFill} from "react-icons/bs";
import {MdClass, MdEdit, MdPhotoCamera, MdPhotoSizeSelectActual, MdPrint} from "react-icons/md";
import {RiFileUserFill, RiToolsFill} from "react-icons/ri";
import React, {useEffect, useRef, useState} from "react";
import Icon from "antd/es/icon";
import {useHistory} from "react-router-dom";


const WorkerResume = (props) => {
  let data = props.data

  const history = useHistory();
  const typeResume = useRef(data.profile?.profile_picture)
  const [takePictureType, setTakePictureType] = useState(undefined)
  const [typePrintButton, setTypePrintButton] = useState()

  const editInformation = () => {
    history.push('/painel/prestador/editar-meu-curriculo')
  }

  const checkTypeButton = () => {
    if (data.profile.profile_picture !== null) {
      setTypePrintButton("withPicture")
    } else {
      setTypePrintButton("withOUT")
    }
  }

  const printResume = (bool) => {
    if (bool) {
      typeResume.current = data.profile.profile_picture;
      setTakePictureType('withProfilePicture')
    } else {
      typeResume.current = null;
      setTakePictureType('withoutProfilePicture')
    }
  }


  useEffect(() => {
    checkTypeButton()
    if(takePictureType !== undefined) {
      window.print();
    }
  },[takePictureType])


  return (
      <Row className='mainContentPage' style={{display:"flex", maxWidth: '1000px', paddingTop: 60, justifyContent:"center", background: "white", borderRadius: 20}}>
        <Row className={'buttonToHide'} style={{position: 'fixed', zIndex: 100,  bottom: 30, left: 0, width: '100%', display: 'flex', justifyContent: 'center', gap:10}}>
          <Button onClick={()=> editInformation()} className={'ant-btn-green'}>
            <span style={{display:"flex", alignItems:"center", gap:8}}>
              <MdEdit/>Editar informações
            </span>
          </Button>
          {typePrintButton === 'withPicture' ?
              <Popconfirm title={'Deseja imprimir o currículo: '}
                        okText='Com foto'
                        icon={<Icon type="question-circle" />}
                        onConfirm={() => printResume(true)}
                        onCancel={() => printResume(false)}
                        cancelText='Sem foto'
                        placement='topRight'>
                <Button type={'primary'} >
                  <span style={{display:"flex", alignItems:"center", gap:8}}>
                    <MdPrint/> Imprimir/Salvar currículo
                  </span>
                </Button>
              </Popconfirm> :
              <Button onClick={()=> window.print()} type={'primary'} >
                  <span style={{display:"flex", alignItems:"center", gap:8}}>
                    <MdPrint/> Imprimir/Salvar currículo
                  </span>
              </Button>
          }

        </Row>
        <Col span={18} style={{display:"flex", flexDirection:"column"}}>
          <Col span={24} style={{display:"flex", gap:10}}>
            <Col span={typeResume.current ? 18 : 24} style={{display:"flex",flexDirection: "column", gap:8}}>
              <Col span={24} style={{fontSize:32, borderBottom: '1px solid #f2f2f2'}}>
                {data?.profile?.social_name || data.profile.name}
              </Col>

              <Col span={24} style={{display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:16}}>
                <div className='font-size-16'>
                  <Icon type="star" theme="filled" /> {moment().diff(data.profile.birthday, 'years')} Anos
                </div>
                <div className='font-size-16'>
                  <FaUserGraduate/> {data.profile.schooling}
                </div>
                <div className='font-size-16'>
                  {data.profile.emails.map((item) => {
                    return (
                        <div>
                          {item.primary &&
                              <span>
                                <Icon type="mail" theme="filled"/> {item.email}
                              </span>
                          }
                        </div>
                    )
                  })}
                </div>
                <div className='font-size-16'>
                  {data.profile.phone_numbers.length > 0 &&
                      <span>
                        {data.profile.phone_numbers.map((item) => (
                            <div>
                              <Icon type="phone" theme="filled" />{maskPhone(item.number)}
                            </div>
                        ))}
                      </span>
                  }
                </div>
              </Col>
            </Col>
            {typeResume.current &&
                <Col span={6} style={{display: 'flex', justifyContent: 'center'}}>
                  <Avatar style={{width:'8rem', height: '8rem'}} src={data.profile.profile_picture}/>
                </Col>
            }
          </Col>

          {data.profile.about_me &&
              <div>
                <Row type={'flex'} style={{marginTop: 16, marginBottom: 20, flexFlow: 'row'}}>
                  <div>
                <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                  <FaUser/> Sobre mim
                </span>
                  </div>
                  <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
                </Row>
                <Row>
                  <Col className='font-size-16' style={{textAlign:'justify'}} span={24}>
                    <div>
                      <p >{`${data.profile.about_me}.`}</p>
                    </div>
                  </Col>
                </Row>
              </div>
          }

          {(data.work_experience?.length > 0 && !props.isFirstJob) &&
              <Row type={'flex'} style={{marginTop: 16, marginBottom: 20, flexFlow: 'row'}}>
                <div>
                  <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                    <BsFillBriefcaseFill/> Experiências
                  </span>
                </div>
                <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
              </Row>
          }

          <Row gutter={[12,12]} style={{display: "flex", flexWrap: "wrap", alignItems: "stretch"}}>
            {data.work_experience?.map((item, index) => {
              if ((item.start_date !== item.end_date)) {
                return (
                    <Col span={12} key={index} >
                      <Row style={{marginBottom: 10, paddingBottom: 10}}>
                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Cargo: </strong>
                            <strong style={{color: '#4caf50'}}>{item.occupation} </strong>
                          </label>
                        </Col>

                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Empresa: </strong>
                            {item.company}
                          </label>
                        </Col>

                        {item.last_wage &&
                            <Col xs={24}>
                              <label>
                                <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Último salário: </strong>
                                {item.last_wage ? <span>R$ {item.last_wage}</span> : 'Não informado'}
                              </label>
                            </Col>
                        }

                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Tipo de trabalho: </strong>
                            {item.work_type}
                          </label>
                        </Col>

                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Local: </strong>
                            {item.location}
                          </label>
                        </Col>

                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Descrição do serviço: </strong>
                            <p>
                              {item.description ? item.description : 'Não informado'}
                            </p>
                          </label>
                        </Col>

                        {(item.work_type !== 'Freelance' && item.work_type !== 'Autônomo') ?
                            <Col xs={24} md={24}>
                              <span>
                                  <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Experiencia Formal: </strong>
                                  <span>{props.convertDate(item.end_date, item.start_date)}</span>
                                  ( Inicio - {moment(item.start_date, 'YYYY-MM').format('MM/YYYY')} ) &nbsp; {item.end_date &&
                                  <span> {'('}Fim - {moment(item.end_date, 'YYYY-MM').format('MM/YYYY')} {')'}</span>}
                              </span>
                            </Col> :
                            <Col xs={24} md={24}>
                              <span>
                                  <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Experiencia Informal: </strong>
                                  <span>{props.convertDate(item.end_date, item.start_date)}</span>
                                  ( Inicio - {moment(item.start_date, 'YYYY-MM').format('MM/YYYY')} ) &nbsp; {item.end_date &&
                                  <span>{'('} Fim - {moment(item.end_date, 'YYYY-MM').format('MM/YYYY')} {')'}</span>}
                              </span>
                            </Col>
                        }
                      </Row>
                    </Col>
                )
              }
            })}
          </Row>

          <Row type={'flex'} style={{marginTop: 30, marginBottom: 20, flexFlow: 'row'}}>
            <div>
              <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                <MdClass/> Pretensões
              </span>
            </div>
            <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
          </Row>
          <Row gutter={[12,12]}>
            {data.work_experience?.map((item, index) =>
                <Col xs={12} key={index}>
                  <label>
                    <span style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}>
                      {item.occupation}
                    </span>
                  </label>
                </Col>
            )}
          </Row>

          {data.academic?.length > 0 &&
              <Row type={'flex'} style={{marginTop: 30, marginBottom: 20, flexFlow: 'row'}}>
                <div>
                  <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                    <FaUserGraduate/> Graduações
                  </span>
                </div>
                <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
              </Row>
          }
          <Row>
            {data.academic?.map((item, index) =>(
                <Col span={12} key={index}>
                  <Row  style={{marginBottom: 10, paddingBottom: 10}}>

                    <Col xs={24}>
                      <label>
                        <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}>Curso:</strong>
                        <strong style={{color: '#4caf50'}}> {item.course} </strong>
                      </label>
                    </Col>

                    <Col xs={24}>
                      <label>
                        <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}>
                          Instituição:
                        </strong>
                        {item.university}
                      </label>
                    </Col>

                    <Col xs={24}>
                      <label>
                        <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Nível:</strong>
                        {item.academic_degree}
                      </label>
                    </Col>

                    <Col xs={24}>
                        <span>
                          <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Inicio: </strong>
                          {item.start_date ? moment(item.start_date, 'YYYY-MM').format('MM/YYYY') : 'Não informado'}
                        </span>
                    </Col>

                    {item.end_date && (
                        <Col xs={24}>
                          <span>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Fim: </strong>
                            {item.end_date ? moment(item.end_date, 'YYYY-MM').format('MM/YYYY') : 'Não informado'}
                          </span>
                        </Col>)
                    }
                  </Row>
                </Col>))
            }
          </Row>

          {data.courses?.length > 0 &&
              <Row type={'flex'} className={`${typeResume.current ? '' : 'pmt'}`} style={{marginTop: 30, marginBottom: 20, flexFlow: 'row'}}>
                <div>
                  <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                    <RiToolsFill/> Cursos
                  </span>
                </div>
                <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
              </Row>
          }
          <Row  gutter={[12,12]}>
            {data.courses?.map((item, index) => (
                <Col span={12}>
                  <Row key={index} style={{marginBottom: 10, paddingBottom: 10}}>
                    <Col xs={24}>
                      <label>
                        <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Curso: </strong>
                        <strong style={{color: '#0072d6'}}>
                          {item.name}
                        </strong>
                      </label>
                    </Col>

                    <Col xs={24}>
                      <label>
                        <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Instituição: </strong>
                        {item.institution}
                      </label>
                    </Col>

                    {item.duration && (
                        <Col xs={24}>
                          <label>
                            <strong style={{fontSize: 14, color: 'rgba(0,0,0,0.85)'}}> Duração: </strong>
                            {item.duration ? <span> {item.duration} meses </span> : 'Não informado'}
                          </label>
                        </Col>)
                    }
                  </Row>
                </Col>)
            )}
          </Row>

          {data.knowledge?.length > 0 &&
            <>
              <Row type={'flex'} style={{marginTop: 30, marginBottom: 20, flexFlow: 'row'}}>
                <div>
              <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                <FaMedal/> Habilidades
              </span>
                </div>
                <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
              </Row>

              <Row style={{marginBottom:-10}}>
                {data.knowledge.map((item, index) => (
                    <Col xs={12} md={8} style={{paddingBottom:10}}>
                      <strong style={{fontWeight: 'bold', fontSize: 14, color: 'rgba(0,0,0,0.85)'}}>{item.title}</strong> - {item.level === '1' ? 'Básico' : item.level === '2' ? 'Intermediário' : 'Avançado' }
                    </Col>
                ))}
              </Row>
            </>
          }

          <Row type={'flex'} style={{marginTop: 30, marginBottom: 20, flexFlow: 'row'}}>
            <div>
              <span style={{color: "#0f75bc", fontSize: 18, whiteSpace: 'nowrap'}}>
                  <RiFileUserFill/> Outras Informações
              </span>
            </div>
            <div style={{width: '100%', marginBottom: 6, marginLeft: 5, borderBottom: '1px solid #0f75bc'}} />
          </Row>

          <Row style={{marginTop:24, display: 'flex', flexWrap: "wrap"}}>
            <Col span={8} className='min-height' >
              <div style={{display:"flex", flexWrap:"wrap"}} className={`profile-description-item` }>
                <p style={{fontWeight: 'bold', marginBottom: 2}}>
                  Pretensão salarial:
                </p>
                <span>{ 'R$ ' + data.profile.wage_claim}</span>
              </div>
            </Col>

            <Col  span={8} className='min-height'>
              <props.DescriptionItem title="Estudante" content={data.profile.is_student ? "Sim" : "Não"}/>
            </Col>

            <Col  span={8} className='min-height'>
              <props.DescriptionItem title="Gênero" content={props.genders[data.profile.gender]}/>
            </Col>

            <Col  span={8} className='min-height'>
              <props.DescriptionItem title="Habilitação" content={data.profile.driver_license || 'Não possuo'}/>
            </Col>

            <Col  span={8} className='min-height' >
              <div className="profile-description-item">
                <p style={{fontWeight: 'bold', marginBottom: 2}}>
                  Veículos:
                </p>
                {data.profile.vehicles?.length !== 0 ?
                    <ul style={{lineHeight: '22px', paddingLeft: 17}}>
                      {data.profile.vehicles?.map((el, index) => <li key={index}>{el}</li>)}
                    </ul> :
                    'Nenhum'
                }
              </div>
            </Col>

            <Col  span={8} className='min-height' >
              <div className="profile-description-item">
                <p style={{fontWeight: 'bold', marginBottom: 2}}>
                  Outras Idiomas:
                </p>
                {data.profile.languages?.length !== 0 ?
                    <ul style={{lineHeight: '22px', paddingLeft: 17}}>
                      {data.profile.languages?.map((el, index) => <li key={index}>{el}</li>)}
                    </ul>
                    :
                    'Nenhum'
                }
              </div>
            </Col>

            <Col  span={8} className='min-height' >
              <div className="profile-description-item">
                <p style={{fontWeight: 'bold', marginBottom: 2}}>
                  Disponibilidade para:
                </p>
                <ul style={{lineHeight: '22px', paddingLeft: 17}}>
                  <li>Realizar viagens? {data.profile.available_travel ? "Sim" : "Não"}</li>
                  <li>Dormir no local de trabalho? {data.profile.available_sleep_duty ? "Sim" : "Não"}</li>
                  <li>Ausentar-se por longo período? {data.profile.available_leave_home ? "Sim" : "Não"} </li>
                </ul>
              </div>
            </Col>

            <Col  span={8} className='min-height'>
              <div className="profile-description-item">
                <p style={{fontWeight: 'bold', marginBottom: 2}}>
                  PcD:
                </p>
                {data.profile.disabilities?.length !== 0 ?
                    <ul style={{lineHeight: '22px', paddingLeft: 17}}>
                      {data.profile.disabilities?.map((el, index) => <li key={index}>{el}</li>)}
                    </ul> :
                    'Nenhuma'
                }
              </div>
            </Col>

            {data.profile.training_interests &&
                <Col  span={8} className='min-height'>
                  <div className='profile-description-item'>
                    <p style={{fontWeight: 'bold', marginBottom: 2}}>
                      Interesse em realizar cursos  de:
                    </p>
                    <ul style={{lineHeight: '22px', paddingLeft: 17}}>
                      {data.profile.training_interests.map((el) =>
                          <li>{el}</li>)
                      }
                    </ul>
                  </div>
                </Col>
            }
          </Row>
        </Col>
      </Row>

  )
}

export default WorkerResume
